export default __webpack_public_path__ + "static/certik-892698a0afae6d661913472017e3067a.svg";